import React, { useState } from 'react'
import { Card, CardBody, Col, Row } from 'reactstrap'
import { ReactComponent as DownArrow } from "assets/img/svg/downarrow.svg"
import { ReactComponent as Uparrow } from "assets/img/svg/upwardArrow.svg";
import { refundDetail, studentDetails } from './constant';
import RectificationRefund from 'modules/studentRefund/rectificationRefund';
import MultiTypeRefundDetailsCard from './viewMultiTypeRefundDetails';
import InfoField from './components/InfoField';
import moment from 'moment';
import { getFormatedDate } from '../../../../views/pages/manage/unAssigned/concessionApproval/common';

const StudentRefundDetail = ({
    details,
    dropdownData
}) => {
    const [open, setOpen] = useState({ student: true, refund: true, refundAccount: true })
    const rectificationRefundTypes = ['RECTIFICATION_REFUND', 'INTERNAL_REFUND'];

    console.log('details', details);
    return (
        <>
            <Card >
                <CardBody>

                    <div className='d-flex justify-content-between align-items-center'>
                        <div className='dark-text label-color'>Student Details</div>
                        <div className="cursor" onClick={() => { setOpen((prev) => ({ ...prev, student: !prev?.student })) }}>{open?.student ? <Uparrow /> : <DownArrow />}</div>
                    </div>
                    {open?.student && <>
                        <div className='mt-24' style={{ borderBottom: " 1px solid #E2E2E2" }}></div>
                        <Row>
                            {studentDetails(details?.orderType).map((item,index) => (
                                <InfoField
                                    key={item.key}
                                    label={item.label}
                                    value={details?.[item.key]}
                                    flag={item.flag}
                                    index={index}
                                    extraComponent={item?.extraComponent}
                                    dropdownData={dropdownData}
                                />
                            ))}
                        </Row >
                    </>}
                </CardBody>
            </Card>
            {(details?.orderType == "COMPLETION_REFUND") && <Card >
                <CardBody>
                    <div className='d-flex justify-content-between align-items-center'>
                        <div className='dark-text label-color'>Refund details</div>
                        <div className="cursor" onClick={() => { setOpen((prev) => ({ ...prev, refund: !prev?.refund })) }}>{open?.refund ? <Uparrow /> : <DownArrow />}</div>
                    </div>
                    {open?.refund && <>
                        <div className='mt-24' style={{ borderBottom: " 1px solid #E2E2E2" }}></div>
                        <Row>
                            {refundDetail(details.paymentAccountDetails).map((item,index) => (
                                <InfoField
                                    key={item.key}
                                    label={item.label}
                                    value={{
                                         ...details?.paymentAccountDetails, 
                                         paymentModeDate : getFormatedDate(details?.paymentAccountDetails?.paymentModeDate, false, 'DD/MM/YYYY'),  
                                         orderType: details?.orderType 
                                        }?.[item?.key]
                                    }
                                    flag={item.flag}
                                    index={index}
                                    extraComponent={item?.extraComponent}
                                />

                            ))}
                        </Row></>}
                </CardBody>
            </Card>}
            {details?.orderType === 'MULTI_TYPE_REFUND' && <MultiTypeRefundDetailsCard details={details} />}
            {rectificationRefundTypes.includes(details?.orderType) && <RectificationRefund details={details} />}

        </>

    )
}
export default StudentRefundDetail